import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { countryModification, getSingleCountry } from "./CreateCountryAction";
import { useForm } from "react-hook-form";
import { useParams , useNavigate,Link} from 'react-router-dom';
import Swal from "sweetalert2";
import { getAllCountry} from "./countryListAction";
import { FaArrowLeft } from 'react-icons/fa';


const initialState = {
  id: "",
  country: "",
  status: "",

}



const ModifyCountry = () => {
  let navigate = useNavigate();
    const {id}=useParams();
  //  console.log('modify'+id);
    const { isLoading, mstatus, message, mmessage } = useSelector((state) => state.countryList);

    const dispatch = useDispatch();
    
    const [countries, setCountries] = useState(initialState);
    
    //const [country, setCountry] = useState('');
    const [status, setStatus] = useState(0);
    const [modify, setModify] = useState(0);
  
    // console.log('name '+getUserProfile.name);
    const countryData = useSelector((state) => state.countryList);
   
    useEffect(() => {
      dispatch(getAllCountry());
     
  }, [dispatch,mmessage]);


    const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      loadCountry(id);
      return;
    }

  });
   useEffect(() => { 
   
    loadCountry(id);
    setCountries({id:id,country:"",status:""});
     }, []);

     
     
 
    const { register, handleSubmit, formState: { errors } } = useForm();

   

    function loadCountry(id){
      dispatch(getSingleCountry(id));
      setCountries({id:id,country:uData.country_name,status:uData.status});
   }

  
   const uData = JSON.parse(JSON.stringify(countryData.countries));
   

  const handleOnChange = e => {
    const name = e.target.name;
    const value = e.target.value;
   
    setCountries({ ...countries, [name]: value });
  
  };
  
  
  
  const handleOnSubmit = (e) => {
    e.preventDefault();
    const { id, country, status } = countries;
    
    if (country === "" && status === "") {
      Swal.fire('No changes made!', '', 'info');
      navigate('/countryList');
      return;
    }
  
    Swal.fire('Country Updated Successfully!', '', 'success');
    const countryUpdation1 = {
      id,
      country,
      status
    };
  
    dispatch(countryModification(countryUpdation1));
    setModify(1);
    navigate('/countryList');
  };
  

 
  return (
    <>
             <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-50px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Modify Country</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/countryList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={handleOnSubmit}>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridUsername">
                  <Form.Label>Name</Form.Label>
                  <Form.Control type="hidden" name="id" autoComplete='off' value={id} />
                 <Form.Control type="text"  name="country" value={countries.country ? countries.country : uData.country_name} autoComplete='off' placeholder="Enter Country" {...register("country", { required: true, maxLength: 10 })} onChange={handleOnChange}/>
                 
                </Form.Group>
                {errors.country && <p>Please check the First Name</p>}
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status" value={countries.status ? countries.status : uData.status}  {...register("status")} onChange={handleOnChange}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                </Form.Group>
              </Row>
              <div class="d-grid  col-2 mx-auto">
              <Button variant="primary" type="submit" className='align-middle'>
                Submit
              </Button>
              </div>
              {isLoading && (<Spinner variant='info' animation='border' />)}

            </Form>
            </div>
            </div>
            </div>
    </>
  );
}

export default ModifyCountry;